(function () {
  /* menu mobile */
  var btn = document.querySelector('[data-menu]'), nav = document.getElementById('menu');
  if (btn && nav) btn.addEventListener('click', function () { var o = nav.classList.toggle('is-open'); btn.setAttribute('aria-expanded', o); });

  /* fiche produit : variantes et miniatures */
  var variants = document.querySelector('[data-variants]');
  if (variants) {
    var selects = document.querySelectorAll('[data-option]'), add = document.querySelector('[data-add]'), price = document.querySelector('[data-price]');
    var sync = function () {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; }).join('|');
      Array.prototype.forEach.call(variants.options, function (o) {
        if (o.dataset.options !== chosen) return;
        variants.value = o.value;
        var ok = o.dataset.available === 'true';
        if (add) { add.disabled = !ok; add.classList.toggle('button--soldout', !ok); add.textContent = ok ? 'Ajouter au panier' : 'Sold out'; }
        if (price) price.textContent = o.dataset.price;
      });
    };
    Array.prototype.forEach.call(selects, function (s) { s.addEventListener('change', sync); });
  }
  var main = document.querySelector('.product__main img');
  document.querySelectorAll('[data-thumb]').forEach(function (b) {
    b.addEventListener('click', function () { if (main) { main.removeAttribute('srcset'); main.src = b.dataset.thumb; } });
  });

  /* formulaire de rachat :
     1. photos : compressées dans le navigateur puis envoyées sur le CDN Shopify via un produit interne
        « Photos rachat » (ajout au panier puis retrait immédiat) ; les liens sont ajoutés à l'email
     2. remplit le nom complet pour l'email de notification
     3. enregistre aussi la demande comme fiche client (tag « demande-rachat »)
     4. envoie le formulaire normalement (email de notification au propriétaire) */
  var form = document.querySelector('[data-rachat]');
  if (!form) return;
  var box = form.querySelector('[data-photos]');
  var files = [];
  var btn = form.querySelector('[data-submit]');
  var MAX = box ? parseInt(box.getAttribute('data-max'), 10) || 6 : 0;

  function msg(text, err) {
    if (!box) return;
    var m = box.querySelector('[data-photos-msg]');
    m.hidden = !text; m.textContent = text || ''; m.classList.toggle('is-error', !!err);
  }
  function renderPhotos() {
    var grid = box.querySelector('[data-photos-grid]'), add = grid.querySelector('.photos__add');
    grid.querySelectorAll('.photos__item').forEach(function (n) { n.remove(); });
    files.forEach(function (f, idx) {
      var fig = document.createElement('div'); fig.className = 'photos__item';
      var img = document.createElement('img'); img.alt = ''; img.src = f.url; fig.appendChild(img);
      var del = document.createElement('button'); del.type = 'button'; del.className = 'photos__del'; del.setAttribute('aria-label', 'Retirer la photo');
      del.innerHTML = '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      del.addEventListener('click', function () { URL.revokeObjectURL(f.url); files.splice(idx, 1); renderPhotos(); });
      fig.appendChild(del); grid.insertBefore(fig, add);
    });
    box.classList.toggle('has-files', files.length > 0);
    box.classList.toggle('is-full', files.length >= MAX);
    msg('');
  }
  function addFiles(list) {
    var skipped = false;
    Array.prototype.forEach.call(list, function (f) {
      if (!/^image\//.test(f.type)) return;
      if (files.length >= MAX) { skipped = true; return; }
      files.push({ file: f, url: URL.createObjectURL(f) });
    });
    renderPhotos();
    if (skipped) msg(MAX + ' photos maximum.', true);
  }
  if (box) {
    var input = box.querySelector('[data-photos-input]');
    input.addEventListener('change', function () { addFiles(input.files); input.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) { box.addEventListener(ev, function (e) { e.preventDefault(); box.classList.add('is-drag'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { box.addEventListener(ev, function (e) { e.preventDefault(); box.classList.remove('is-drag'); }); });
    box.addEventListener('drop', function (e) { if (e.dataTransfer) addFiles(e.dataTransfer.files); });
  }

  // réduit chaque photo (1600 px max, JPEG) pour un envoi rapide depuis un téléphone
  function shrink(file) {
    return new Promise(function (resolve) {
      var img = new Image(), url = URL.createObjectURL(file);
      img.onload = function () {
        var k = Math.min(1, 1600 / Math.max(img.naturalWidth, img.naturalHeight));
        var c = document.createElement('canvas'); c.width = Math.round(img.naturalWidth * k); c.height = Math.round(img.naturalHeight * k);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        c.toBlob(function (b) { resolve(b || file); }, 'image/jpeg', 0.85);
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
      img.src = url;
    });
  }
  function uploadPhotos() {
    if (!box || !files.length) return Promise.resolve([]);
    var variant = box.getAttribute('data-variant');
    return Promise.all(files.map(function (f) { return shrink(f.file); })).then(function (blobs) {
      var fd = new FormData();
      fd.append('id', variant); fd.append('quantity', '1');
      blobs.forEach(function (b, i) { fd.append('properties[Photo ' + (i + 1) + ']', b, 'photo-' + (i + 1) + '.jpg'); });
      return fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/json' } });
    }).then(function (r) { if (!r.ok) throw new Error('upload'); return r.json(); }).then(function (item) {
      var it = item.items ? item.items[0] : item, props = it.properties || {}, urls = [];
      Object.keys(props).forEach(function (k) { var v = String(props[k] || ''); if (/^Photo/.test(k) && v) urls.push(v.indexOf('//') === 0 ? 'https:' + v : v); });
      // retire la ligne technique du panier
      return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: it.key, quantity: 0 }) })
        .then(function () { return urls; }, function () { return urls; });
    });
  }

  var sent = false;
  form.addEventListener('submit', function (e) {
    if (sent) return;
    e.preventDefault();
    if (box && !files.length) { msg('Ajoute au moins une photo de ton article.', true); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    var val = function (n) { var el = form.querySelector('[name="contact[' + n + ']"]:checked') || form.querySelector('[name="contact[' + n + ']"]'); return el ? el.value.trim() : ''; };
    var first = form.querySelector('[data-first]').value.trim(), last = form.querySelector('[data-last]').value.trim();
    form.querySelector('[data-fullname]').value = (first + ' ' + last).trim();
    if (btn) { btn.disabled = true; btn.textContent = files.length ? 'Envoi des photos…' : 'Envoi…'; }

    uploadPhotos().then(function (urls) {
      var out = box && box.querySelector('[data-photos-urls]');
      if (out) out.value = urls.length ? urls.join('\n') : (files.length ? 'Photos non reçues (' + files.length + ') : redemander au client.' : '');
    }, function () {
      var out = box && box.querySelector('[data-photos-urls]');
      if (out) out.value = 'Photos non reçues (' + files.length + ') : redemander au client.';
    }).then(function () {
      if (btn) btn.textContent = 'Envoi…';
      var clean = function (s) { return s.replace(/[,]/g, ' ').slice(0, 60); };
      var tags = ['demande-rachat', 'marque: ' + clean(val('Marque')), 'article: ' + clean(val('Article')), 'taille: ' + clean(val('Taille')),
        'etat: ' + clean(val('État').replace(/[★☆]/g, '').trim()), 'prix: ' + clean(val('Prix')) + ' €', 'tel: ' + clean(val('Téléphone')),
        'facture: ' + val('Facture'), 'boite: ' + val('Boîte')].join(', ');
      var fd = new FormData();
      fd.append('form_type', 'customer'); fd.append('utf8', '✓');
      fd.append('contact[email]', val('email')); fd.append('contact[first_name]', first); fd.append('contact[last_name]', last);
      fd.append('contact[tags]', tags);
      var done = function () { sent = true; form.submit(); };
      var timer = setTimeout(done, 2500);
      try {
        fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' }).then(function () { clearTimeout(timer); done(); }, function () { clearTimeout(timer); done(); });
      } catch (err) { clearTimeout(timer); done(); }
    });
  });
})();
